import Moment from 'moment';

export default {
  filters: {
    dateFormat(value) {
      if (!value) {
        return '';
      }
      return Moment(value.toString()).format('MM/DD/YYYY hh:mm');
    },
  },
  methods: {
    $getFormattedDate(date) {
      if (!date) {
        return '';
      }
      return Moment(date.toString()).format('MM/DD/YYYY hh:mm');
    },
  },
};
